<template>
    <div>

        <!-- upload progress -->
        <div v-show="isUploading">
            
            <v-progress-linear
              color="primary"
              :value="progress"
            ></v-progress-linear>

            <p class="text-center py-2">
                Caricamento in corso...
            </p>

        </div>

        <!-- dropzone -->
        <div v-show="!isUploading">

            <vue2-dropzone ref="dropzone" 
                       id="dropzone" 
                       :options="dropzoneOptions"
                       @vdropzone-success="onFileUpload"
                       @vdropzone-error="onFileError"
                       @vdropzone-files-added="onFileAdded"
                       @vdropzone-removed-file="onFileRemoved"
                       @vdropzone-complete-multiple="onUploaded"
                       @vdropzone-upload-progress="onProgress">
            </vue2-dropzone>

            <p class="text-center mt-2">
                <v-icon small>
                    mdi-information
                </v-icon>
                <small v-if="maxUploads">
                    Puoi caricare massimo {{ maxUploads }} file.
                </small>
                <small>
                    La dimensione massima di ciascun file è {{ dropzoneOptions.maxFilesize }}MB.
                </small>
            </p>

            <v-row class="mt-5">
                <v-col class="d-flex">

                    <v-btn depressed 
                           @click="removeFiles"
                           :disabled="!filesCount">
                        Cancella file
                    </v-btn>

                    <v-spacer/>

                    <v-btn :disabled="!canUpload"
                           color="success"
                           @click="upload"
                           depressed>
                        Carica file
                    </v-btn>

                </v-col>
            </v-row>
            
        </div>

    </div>
</template>

<script>
import API from '@/api'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import { mapGetters, mapActions } from 'vuex'

import Action from '@/models/action'

export default 
{
   name: 'ActionProviderFileUploadUploader',

   mixins: [],

   components: 
   {
    vue2Dropzone
   },

   data: () => ({
    filesCount: 0,
    isUploading: false,
    progress: 0
   }),

   props: {
    action: {
        type: Action,
        required: true
    }
   },

   computed: 
   {
    ...mapGetters({
        apiToken: 'auth/apiToken'
    }),

    dropzone()
    {
        return this.$refs.dropzone
    },

    dropzoneOptions()
    {
        const actionId = this.action.id, 
              uploadUrl = API.getUrl(`action/${actionId}/complete`, true),
              apiToken = this.apiToken

        /**
         * @see https://docs.dropzone.dev/configuration/basics/configuration-options
         */
        return {
          url: uploadUrl,
          autoProcessQueue: false,
          uploadMultiple: true,
          thumbnailWidth: 150,
          createImageThumbnails: true,
          parallelUploads: 100,
          maxFiles: this.maxUploads,
          acceptedFiles: 'image/*,application/pdf',
          maxFilesize: 5, // in MB
          paramName: "file",
          withCredentials: true,
          headers: { "Authorization": `Bearer ${apiToken}` },
          init: this.onDropzoneInit
        }
    },

    canUpload()
    {
        const hasFiles = ( this.filesCount > 0 ),
              checkMaxUploads = ( !this.maxUploads || this.filesCount <= this.maxUploads )

        return hasFiles && checkMaxUploads
    },

    maxUploads()
    {
        return this.action.componentMeta.max_uploads
    }

   },

   methods:
   {
    ...mapActions({
        growl: 'growler/growl'
    }),

    upload()
    {
        this.isUploading = true

        this.dropzone.processQueue()
    },

    removeFiles()
    {
        if( this.dropzone )
            this.dropzone.removeAllFiles()
    },

    onDropzoneInit()
    {

    },

    onFileAdded(file)
    {
        this.filesCount += file.length
    },

    onFileRemoved(file)
    {
        this.filesCount--

        console.log(file)
    },

    onFileUpload(file, res)
    {
        console.log(file, res)
    },

    onFileError(file, err)
    {
        if( file.status == 'canceled' )
            return

        const message = (typeof err == 'string') ? err : err.message

        this.growl({
            content: message,
            color: 'error'
        })

        // show error in Dropzone
        file.previewElement
            .querySelector('.dz-error-message span')
            .innerHTML = message
    },

    onProgress(file, progress)
    {
        console.log(file)

        this.progress = progress
    },

    onUploaded()
    {
        this.isUploading = false

        let action = this.action

        this.$emit('uploaded', { action } )
    }

   },

   mounted()
   {

   }
}
</script>